import { action, makeObservable, observable } from 'mobx';

class ConfigStore {
   JWT_KEY = "site";
  @observable jwtToken: Nullable<string> = localStorage.getItem(this.JWT_KEY) || "";
  @observable email: Nullable<string> = "";
  @observable password: Nullable<string> = "";

  @action setJwtToken = (token: string) => {
    this.jwtToken = token;
    this.addJwtToLocalStorage(token);
  };

  @action setPassword = (password: string) => {
    this.password = password;
  };

  @action setEmail = (email: string) => {
    this.email = email;
  };

  @action removeJwtToken = () => {
    this.setJwtToken("");
    this.removeJwtFromLocalStorage();
  };

  @action private addJwtToLocalStorage = (value: string) => {
    localStorage.setItem(this.JWT_KEY, value);
  };

  @action private removeJwtFromLocalStorage = () => {
    localStorage.removeItem(this.JWT_KEY);
  };

  constructor() {
    makeObservable(this);
  }
}

export default ConfigStore;
